import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import { ContentContainer, SocialBox } from "./ArticlesPreview.component";

gsap.registerPlugin(ScrollTrigger);

const animationLayout = (wrapperRef) => {
    const ref = wrapperRef.current;

    if (!ref) return;

    const photoElement = ref.querySelector("a");
    const descriptionElement = ref.querySelector(`${ContentContainer}`);
    const socialBoxElement = ref.querySelector(`${SocialBox}`);

    const targets = [photoElement, descriptionElement].filter(Boolean);

    if (socialBoxElement) {
        targets.push(socialBoxElement);
    }

    if (targets.length === 0) return;

    // Set initial state
    gsap.set(targets, { opacity: 0, y: 50 });

    // Create scroll trigger
    ScrollTrigger.create({
        trigger: ref,
        start: "top 60%",
        onEnter: () => {
            gsap.to(targets, {
                opacity: 1,
                y: 0,
                duration: 0.8,
                stagger: 0.2,
                ease: "power2.out",
            });
        },
    });
};

export { animationLayout };
